import {poolSlice} from "./poolSlice";

const {actions} = poolSlice;

export const setDataPool = data => dispatch => {
  dispatch(actions.setDataPool({data}));
};
